<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <v-card flat class="flight_info">
          <v-card-text>
            <v-layout row>
              <v-flex xs12>
                <v-container>
                  <v-layout row wrap align-center>
                    <v-flex xs12 sm6 class="pb-4">
                      <h1>Flight Details</h1>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                      <CountdownTimer />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
            <div class="loading" v-if="loading === true">
              <pulse-loader :loading="loading"></pulse-loader>
            </div>
            <div v-else>
              <v-layout row>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-layout column>
                        <v-flex xs12 class="accent--text strong pb-1">
                          DEPARTING FLIGHT #{{ description_departing_flight() }}
                        </v-flex>
                        <v-flex xs12 class="strong primary--text">
                          {{ depart_desc_city }}
                          <v-icon small>arrow_right_alt</v-icon>
                          {{ depart_desc_city2 }}
                        </v-flex>
                        <v-flex xs12>
                          {{ depart_desc_date }}
                          <span class="ml-4">
                            {{ depart_desc_time }}
                          </span>
                        </v-flex>
                      </v-layout>
                      <v-layout column v-show="depart_pass.length > 0" class="mt-3 mb-2">
                        <v-flex xs12 class="primary--text py-2 strong">
                          PASSENGERS:
                        </v-flex>
                        <div v-for="(p, i) in depart_pass" :key="'dp_' + i">
                          <v-flex xs12 class="mb-1" align-center>
                            <v-icon size="6" class="primary--text pa-1">brightness_1</v-icon>
                            {{ p }}
                          </v-flex>
                        </div>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 v-show="return_pass.length > 0" class="ret_fees">
                      <v-layout column>
                        <v-flex xs12 grow class="accent--text strong pb-1">
                          RETURNING FLIGHT #{{ description_returning_flight() }}
                        </v-flex>
                        <v-flex xs12 sm4 grow class="strong primary--text">
                          {{ return_desc_city }}
                          <v-icon small>arrow_right_alt</v-icon>
                          {{ return_desc_city2 }}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs10 sm3>
                          {{ return_desc_date }}
                          <span class="ml-4">
                            {{ return_desc_time }}
                          </span>
                        </v-flex>
                      </v-layout>
                      <v-layout column class="mt-3 mb-2">
                        <v-flex xs12 class="primary--text py-2 strong">
                          PASSENGERS
                        </v-flex>
                        <div v-for="(p, i) in return_pass" :key="'rt_' + i">
                          <v-flex xs12 class="my-1" align-center>
                            <v-icon size="6" class="primary--text pa-1">brightness_1</v-icon>
                            {{ p }}
                          </v-flex>
                        </div>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="pb-1 line-items" v-if="line_items !== null">
                <v-flex xs12 sm6>
                  <v-flex>
                    <p class="primary--text pt-3 strong">
                      DEPARTING FEES
                    </p>
                  </v-flex>
                  <v-flex class="pb-2">
                    Departing Fare Type: {{ dep_fare_type }}
                  </v-flex>
									<v-flex class="atc">Air Transportation Charges</v-flex>
                  <div v-for="(f, i) in line_items.by_type.departing.charge" :key="'df_' + i">
                    <v-flex xs12>
                      <v-layout row wrap class="py-1 mr-2 fees">
                        <v-flex xs12 sm5 grow>
                          {{ f.label }}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs1 shrink v-if="f.qty > 1">
                          {{ f.qty }}
                        </v-flex>
                        <v-flex xs1 v-else>&nbsp;</v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">x</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs3 sm2 shrink v-if="isPercentage(f.each) || f.qty > 1" class="text-right pr-2">
                          {{ f.each }}
                        </v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">=</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs6 sm2 class="text-right">
                          {{ f.total }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>

									<v-flex class="tfc">Taxes, Fees and Charges</v-flex>
                  <div v-for="(f, i) in line_items.by_type.departing.fee" :key="'df_' + i">
                    <v-flex xs12>
                      <v-layout row wrap class="py-1 mr-2 fees">
                        <v-flex xs12 sm5 grow>
                          {{ f.label }}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs1 shrink v-if="f.qty > 1">
                          {{ f.qty }}
                        </v-flex>
                        <v-flex xs1 v-else>&nbsp;</v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">x</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs3 sm2 shrink v-if="isPercentage(f.each) || f.qty > 1" class="text-right pr-2">
                          {{ f.each }}
                        </v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">=</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs6 sm2 class="text-right">
                          {{ f.total }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>

                  <div v-for="(f, i) in line_items.by_type.departing.total" :key="'df_' + i">
                    <v-flex xs12>
                      <v-layout row wrap class="py-1 mr-2 fees subtotal-fees">
                        <v-flex xs12 sm5 grow>
                          {{ f.label }}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs1 shrink v-if="f.qty > 1">
                          {{ f.qty }}
                        </v-flex>
                        <v-flex xs1 v-else>&nbsp;</v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">x</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs3 sm2 shrink v-if="isPercentage(f.each) || f.qty > 1" class="text-right pr-2">
                          {{ f.each }}
                        </v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">=</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs6 sm2 class="text-right">
                          {{ f.total }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>
                </v-flex>
                <v-flex
                  v-if="line_items.return !== undefined && line_items.return.length > 0"
                  class="ret_fees"
                  xs12
                  sm6
                >
                  <v-flex>
                    <p class="primary--text pt-3 strong">
                      RETURNING FEES
                    </p>
                  </v-flex>
                  <v-flex class="pb-2">
                    Returning Fare Type: {{ ret_fare_type }}
                  </v-flex>
									<v-flex class="atc">Air Transportation Charges</v-flex>
                  <div v-for="(f, i) in line_items.by_type.return.charge" :key="'df_' + i">
                    <v-flex xs12>
                      <v-layout row wrap class="py-1 mr-2 fees">
                        <v-flex xs12 sm5 grow>
                          {{ f.label }}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs1 shrink v-if="f.qty > 1">
                          {{ f.qty }}
                        </v-flex>
                        <v-flex xs1 v-else>&nbsp;</v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">x</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs3 sm2 shrink v-if="isPercentage(f.each) || f.qty > 1" class="text-right pr-2">
                          {{ f.each }}
                        </v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">=</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs6 sm2 class="text-right">
                          {{ f.total }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>

									<v-flex class="tfc">Taxes, Fees and Charges</v-flex>
                  <div v-for="(f, i) in line_items.by_type.return.fee" :key="'df_' + i">
                    <v-flex xs12>
                      <v-layout row wrap class="py-1 mr-2 fees">
                        <v-flex xs12 sm5 grow>
                          {{ f.label }}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs1 shrink v-if="f.qty > 1">
                          {{ f.qty }}
                        </v-flex>
                        <v-flex xs1 v-else>&nbsp;</v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">x</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs3 sm2 shrink v-if="isPercentage(f.each) || f.qty > 1" class="text-right pr-2">
                          {{ f.each }}
                        </v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">=</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs6 sm2 class="text-right">
                          {{ f.total }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>

                  <div v-for="(f, i) in line_items.by_type.return.total" :key="'df_' + i">
                    <v-flex xs12>
                      <v-layout row wrap class="py-1 mr-2 fees subtotal-fees">
                        <v-flex xs12 sm5 grow>
                          {{ f.label }}
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs1 shrink v-if="f.qty > 1">
                          {{ f.qty }}
                        </v-flex>
                        <v-flex xs1 v-else>&nbsp;</v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">x</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs3 sm2 shrink v-if="isPercentage(f.each) || f.qty > 1" class="text-right pr-2">
                          {{ f.each }}
                        </v-flex>
                        <v-flex shrink class="px-2" v-if="f.qty > 1">=</v-flex>
                        <v-flex shrink class="px-2" v-else>&nbsp;</v-flex>
                        <v-flex xs6 sm2 class="text-right">
                          {{ f.total }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>
                </v-flex>
              </v-layout>

              <v-divider></v-divider>

							<v-layout row wrap class="promocode-row">
								<v-flex class="promocode-text" v-if="complete!=true">
									<v-text-field
										label="Discount Code"
										v-model="promocode"
										outline
										dense
									></v-text-field>
								</v-flex>
								<v-flex class="promocode-button" v-if="complete!=true">
									<button v-on:click="getSummary()">Apply</button>
								</v-flex>
								<v-flex class="promocode-status">
									<div v-html="line_items.promocode_status"></div>
								</v-flex>
							</v-layout>

              <v-layout row wrap align-center class="pa-3 total">
                <v-spacer></v-spacer>
                <v-flex shrink class="pr-3 mr-3">
                  <h2 class="primary--text">
                    TOTAL:
                  </h2>
                </v-flex>
                <v-flex shrink>
                  <v-layout row wrap align-end>
                    <v-flex xs4 sm3 class="pr-1 mr-2 mb-2 cad">
                      CAD
                    </v-flex>
                    <v-flex xs8 sm4 md3>
                      <h2 class="primary--text">
                        ${{ line_items.total }}
                      </h2>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shared from "@/mixins/Shared";
import CountdownTimer from "@/components/CountdownTimer.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "FlightSummary",
  mixins: [Shared],
  components: {
    PulseLoader,
    CountdownTimer
  },
  mounted() {
    if (this.line_items === null) {
      this.getSummary();
    }
  },
  methods: {
    isPercentage(val) {
      val = val + "";
      const test = val.indexOf("%");
      return test === -1 ? false : true;
		},
		checkPromocode()
		{
			this.getSummary();
			// currently it is live updating claming an invalid code, when we haven't submitted it to check yet.
			// need a way of only showing an error after the code has been checked, probably a v-html showing output from the api in line items array.
		}
  },
	computed: {
    total_price() {
      return this.description_total_cost();
    },
    return_fees() {
      let fees = this.description_fees("return");
      return fees;
    },
    dep_fare_type() {
      return this.description_flight_type();
    },
    ret_fare_type() {
      return this.description_flight_type("return");
    },
    depart_fees() {
      let fees = this.description_fees();
      return fees;
    },
    depart_pass() {
      return this.description_pax();
    },
    return_pass() {
      return this.description_pax("return");
    },
    depart_desc_city() {
      return this.description_departing_city();
    },
    depart_desc_city2() {
      return this.description_departing_city(2);
    },
    depart_desc_date() {
      return this.description_departing_date();
    },
    depart_desc_time() {
      return this.description_departing_time();
    },
    depart_desc_flight() {
      return this.description_departing_flight();
    },
    return_desc_city() {
      return this.description_returning_city();
    },
    return_desc_city2() {
      return this.description_returning_city(2);
    },
    return_desc_date() {
      return this.description_returning_date();
    },
    return_desc_time() {
      return this.description_returning_time();
    },
    return_desc_flight() {
      return this.description_returning_flight();
		}
  }
};
</script>
